import berryCard from './berryCard';
export default berryCard;